import React from 'react';

import { FormikField } from 'components/FormikField';

import { PropertySelectField } from '../PropertySelectField';
import { TransitionDirectionProperty } from '../TransitionDirectionProperty';

import styles from './ReactionPropertyField.module.scss';

type ReactionProperty = {
  key: string;
  value?: unknown;
};

type ReactionPropertyFieldProps = {
  checkable?: boolean;
  readOnly?: boolean;
  namePrefix?: string;
  property: ReactionProperty;
  dependProperty?: ReactionProperty | null;
  onChanged?: (name: string, checked: boolean) => void;
  renderContent: (args: {
    key: string;
    value?: unknown;
    dependValue?: unknown;
  }) => React.ReactNode;
};

const ReactionPropertyField = ({
  checkable,
  readOnly,
  namePrefix,
  property,
  dependProperty,
  onChanged,
  renderContent,
}: ReactionPropertyFieldProps) => {
  if (!checkable || !namePrefix) {
    return (
      <div className={styles.propertyReadOnly}>
        {renderContent({
          key: property.key,
          value: property.value,
          dependValue: dependProperty?.value,
        })}
      </div>
    );
  }

  return (
    <FormikField
      name={namePrefix}
      withControl={false}
      component={PropertySelectField}
      componentProps={{
        type: 'checkbox',
        readOnly,
        property,
        dependProperty,
        renderProperty: renderContent,
        onChanged,
      }}
    />
  );
};

export const ReactionTransitionDirectionField = ({
  checkable,
  readOnly,
  namePrefix,
  property,
  onChanged,
}: Omit<ReactionPropertyFieldProps, 'renderContent' | 'dependProperty'>) => (
  <ReactionPropertyField
    checkable={checkable}
    readOnly={readOnly}
    namePrefix={namePrefix}
    property={property}
    onChanged={onChanged}
    renderContent={() => <TransitionDirectionProperty property={property} />}
  />
);

export default React.memo(ReactionPropertyField);
